import axios from "axios";

/**
 * Axios instance for admin/auth requests.
 *
 * - Always sends cookies (`withCredentials`) so the httpOnly `session_token`
 *   set by `/api/auth/google/session` is presented.
 * - In addition, a Bearer token is attached when available — useful for
 *   environments where third-party cookies are blocked. Tokens are read from
 *   `localStorage.admin_session_token`, written after a successful login.
 */
const api = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  withCredentials: true
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("admin_session_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;
